import {Icon} from 'ant-design-vue';

/**首页图标*/
export const HomeIcon = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2024084_82z1fswiapf.js',
});
